
// @ts-nocheck
import Vue from 'vue'
import {QSpinner, QTooltip, QBanner, QInput, QIcon, QSelect, QSpace} from 'quasar'
import gql from 'graphql-tag'
import List from '../views/List.vue'
import ListToolbar from '@/components/ListToolbar.vue'
import { apolloState } from '@/main'

export default Vue.extend({
    components: { QSpinner, QTooltip, QBanner, QInput, QIcon, QSelect, QSpace, List, ListToolbar },
    data() {
        return {
            rightDrawerOpen: false,
            authed: <any>false,
            lists: [],
            selectedEntries: <any[]>[],
            sharingList: null,
            entries: [],

            filter: {
                query: '',
                postcode: '',
                distance: null,
                responsible: null,
                onlyActive: true,
                state: '',
                isDistanceActive: false,
                isResponsibleActive: false,
                isStateActive: false,
            }
        }
    },
    computed: {
        users() {
            let users: {[name:string]:boolean} = {}
            for(let entry of this.entries) {
                if(entry.responsible && entry.responsible.trim() && !users[entry.responsible]) users[entry.responsible] = true
            }
            return Object.keys(users)
        },
    },
    apollo: {
        authed: gql`query authed {
            authed { id, name }
        }`,
        lists: gql`query lists {
            lists { id, name }
        }`,
        entries: {
            query: gql`query entries($listId: String!) {
                entries(listId: $listId) {
                    id
                    name
                    type
                    mail
                    tel
                    postcode
                    city
                    address
                    contactPerson
                    website
                    products
                    createdAt
                    responsible
                    comment
                    listIds
                    states {
                        listId
                        key
                        comment
                        date
                        pausedUntil
                    }
                    lastState {
                        key
                        comment
                        date
                        pausedUntil
                    }
                    isInList
                }
            }`,
            variables() {
                return { listId: this.authed ? this.authed.id : null }
            },
            skip () {
                return !this.authed || !this.authed.id
            }
        },
        $subscribe: {
            updates: {
                query: gql`subscription updates($listId: String!) {
                    entryUpdated(listId: $listId) {
                        id
                        name
                        type
                        mail
                        tel
                        postcode
                        city
                        address
                        contactPerson
                        website
                        products
                        createdAt
                        responsible
                        comment
                        listIds
                        states {
                            listId
                            key
                            comment
                            date
                            pausedUntil
                        }
                        lastState {
                            key
                            comment
                            date
                            pausedUntil
                        }
                        isInList
                    }
                }`,
                variables() {
                    return {
                        listId: this.authed.id
                    }
                },
                skip () {
                    return !this.authed || !this.authed.id
                },
                result({data}) {
                    // apply update to this.entries
                    const index = (<any>this).entries.findIndex(e => e.id === data.id)
                    if(index !== -1) {
                        Vue.set((<any>this).entries, index, data)
                    } else {
                        (<any>this).entries.push(data.entryUpdated)
                    }
                }
            }
        }
    },
    methods: {
        cancelSharing() {
            this.selectedEntries = []
            this.sharingList = null
        },
        async logout() {
            await this.$apollo.mutate({
                mutation: gql` mutation logout {
                    logout
                }`
            })
            this.$router.push({
                name: 'login'
            })
            window.location.reload()
        },
        onEntryToggle(entries) {
            if(!Array.isArray(entries)) entries = [entries]
            for(let entry of entries) {
                const index = this.selectedEntries.findIndex(s => s.id == entry.id)
                if(index !== -1) {
                this.selectedEntries.splice(index, 1)
                } else {
                this.selectedEntries.push(entry)
                }
            }
        },
        updateFilter({key, value}) {
            this.filter[key] = value
        }
    },
    mounted () {
        if(this.$route.name == 'list') {
            this.rightDrawerOpen = false
        } else {
            setTimeout( () => {
                this.rightDrawerOpen = true
            }, 100)
        }
    },
     // @ts-ignore
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'list') {
            this.rightDrawerOpen = false
        } else {
            this.rightDrawerOpen = true
        }
        setTimeout( () => {
            next()
        }, 30)
    },
    watch: {
        authed(value) {
            console.log({value})
            if(!value) {
                // not loggedin
                this.$router.push({
                    name: 'login'
                })
            }
        }
    },
})
